<template>
	<div class="v-badges">
		<slot/>
	</div>
</template>

<style lang="scss" src="./VBadges.scss"/>

<script lang="ts">
/**
 * VBadges — контейнер для группы VBadge.
 *
 * Раскладывает бейджи в горизонтальный ряд с минимальным gap.
 * При нехватке места переносит на новую строку.
 *
 * Если бейдж один — обёртка не нужна, ставьте VBadge напрямую.
 *
 * @example
 *   <VBadges>
 *     <VBadge v-if="!row.isOfferBased" class="primary">Прямой</VBadge>
 *     <VBadge v-if="row.isSamples">Образцы</VBadge>
 *   </VBadges>
 */
export default defineComponent({
	name: 'VBadges',
});
</script>